export const Policy = () => {
  const btnEl1 = document.querySelector('.cookies-accept-js');
  const btnEl2 = document.querySelector('.cookies-decline-js');
  const modalEl = document.querySelector('.cookies-section');

  if (JSON.parse(localStorage.getItem('status'))) {
    return;
  } else {
    modalEl.style.display = 'block';
  }
  btnEl1.addEventListener('click', () => {
    modalEl.style.display = 'none';
    localStorage.setItem('status', JSON.stringify(true));
  });

  btnEl2.addEventListener('click', () => {
    modalEl.style.display = 'none';
    localStorage.setItem('status', JSON.stringify(false));
  });
};
